export const THEME_CONFIG = {
  token: {
    fontFamily: 'Open Sans',
    colorError: '#cb2027',
    colorErrorText: '#cb2027',
  },
  components: {
    Typography: {
      fontSizeHeading1: 28,
      fontSizeHeading2: 24,
      fontSizeHeading3: 18,
      fontSizeHeading4: 16,
      fontSizeHeading5: 14,
      titleMarginBottom: 0,
      titleMarginTop: 0,
    },
  },
};
